import '@/styles/global.scss';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Rtc from '@/components/Rtc';

createRoot(document.getElementById('rtc-root')!).render(
  <StrictMode>
    <Rtc />
  </StrictMode>,
);
